
import {Component, Vue, Prop} from 'vue-property-decorator';
import {ToggleButton} from 'vue-js-toggle-button';

@Component({
  name: 'price-toggle',
  components: {
    ToggleButton,
  },
})

export default class extends Vue {
  @Prop() private isBusiness: boolean;

  private get priceDisplay(): boolean {
      return this.$store.getters['GlobalSettings/getPriceView'] === 'excl_tax';
  }

  private get manuallyTriggered(): boolean {
    return this.$store.getters['GlobalSettings/getPriceTriggered'];
  }
  private set priceDisplay(value: boolean) {

    this.$store.dispatch('GlobalSettings/setPriceTriggered', true);
    this.$store.dispatch('GlobalSettings/setPriceView', value ? 'excl_tax' : 'incl_tax');
  }
  private created(): void {
    if (!this.manuallyTriggered) {
      if (this.isBusiness === true) {
        this.$store.dispatch('GlobalSettings/setPriceView', 'excl_tax');
      } else {
        this.$store.dispatch('GlobalSettings/setPriceView', 'incl_tax');
      }
    } else if(this.isBusiness === false && this.manuallyTriggered === true) {
      this.$store.dispatch('GlobalSettings/setPriceTriggered', false);
    }
  }
}
